/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

const SCALE_THRESHOLD = 5;

export function getElementsRatio( containerWidth: number, elementWidth: number ): number {
	if ( [ containerWidth, elementWidth ].some( isNaN ) ) {
		return 1;
	}

	const currentScale = ( containerWidth / elementWidth );

	if ( currentScale > 1 ) {
		return 1;
	}

	if ( currentScale < 0.5 ) {
		return 0.5;
	}

	// 0.95, 0.90, 0.85, ..., 0.55.
	return ( Math.floor( ( currentScale * 100 ) / SCALE_THRESHOLD ) * SCALE_THRESHOLD ) / 100;
}
